<div class="container">
  <!-- Loader-->
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="log-widget" *ngIf="!isLoading">
    <div class="time-list" #timeListEl *ngIf="isShowTimeline">
      <ng-container *ngFor="let time of timeList; let i = index">
        <div class="time" [id]="convertTimeListId(time.label)" (click)="moveToSelectedTime(time.label)" [class.disabled]="time.isDisabled"> 
          <div *ngIf="addIconsToMidnightNoon(time.label)" style="margin-right: 4px;">{{addIconsToMidnightNoon(time.label)}}</div>
          <div>{{ time.label }}</div>
        </div>
      </ng-container>
    </div>
    <div class="event-log-container">
      <div class="no-data" *ngIf="!processedLogs.length"><i class="material-icons" style="font-size: 42px;">inventory_2</i>
        <div>No Activity Log</div>
      </div>
      <div *ngIf="processedLogs.length" style="height:100%; min-width: 334px">
        <ng-container *ngFor="let item of processedLogs; let i = index; trackBy: trackByLog">
          <div class="event-log" *ngIf="item.isVisible" appEventLogObserver="appEventLogObserver" [attr.data-log-index]="i" [endSentinelEl]="endSentinelEl?.nativeElement" (click)="onClickLog($event, item, i)" (virtualScroll)="handleVisibility($event)" (isVisible)="showSnapshotOrVideo($event)" (endReached)="closeToLastList($event)">
            <ng-container *ngIf="!item?.specialRow && (!item?.isShowMore)">
              <ng-container *appLogRenderer="{ log: item, timezone, toolbar }"></ng-container>
            </ng-container>
            <ng-container *ngIf="item?.specialRow && (!item?.isShowMore)">
              <div class="hour-mark" [id]="convertHourMarkLabelId(item.label)">
                <div class="hour-mark-line"></div>
                <div class="hour-mark-text">{{item.label}}</div>
                <div class="hour-mark-line"></div>
              </div>
            </ng-container>
            <ng-container *ngIf="item?.isShowMore">
              <div class="show-more" *ngIf="addLogLoading">Loading...
                <div class="loader">
                  <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
                  </svg>
                </div>
              </div>
              <div class="show-more" *ngIf="!addLogLoading" (click)="closeToLastList('recall')">
                 Show More Log</div>
            </ng-container>
            <!-- 정말 마지막 log를 위한 가짜 div-->
            <div class="end-sentinel" #endSentinel data-paging-key="end"></div>
            <!-- -------------------------------->
            <ng-template #toolbar let-log="log">
              <log_tool_bar [log]="log" [isOnlyShowDetail]="isOnlyShowDetail" (onClickEventViewerInToolbar)="onClickEventViewerInToolbar($event)" (onClickLogModalInToolbar)="onClickLogModalInToolbar($event)" (onClickVerificationModalToolbar)="onClickVerificationModalToolbar($event)" (onClickSharedLinkModalToolbar)="onClickSharedLinkModalToolbar($event)" (onClickDownloadLinkModalToolbar)="onClickDownloadLinkModalToolbar($event)"></log_tool_bar>
            </ng-template>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>